import React, { FC, useEffect, useRef, useState } from 'react'
import { Wei } from '../../../utils/types'
import SwapInput from '../../swap/SwapInput'
import { numericalPlaceholder } from '../../../config'
import { fromWei, toWei } from '../../../utils/static-web3'
import SwapInputPanel from '../../swap/SwapInputPanel'
import styled from 'styled-components'
import { Token } from '../../../logic/token/token'
import CurrencyLogo from '../../CurrencyLogo'
import SwapInputSymbol from '../../swap/SwapInputSymbol'
import { coinImage } from '../../../assets/coins/coins'
import SimpleBalance from '../../catalog/SimpleBalance'
import { MaxButton } from '../../catalog/MaxButton'
import { SwapStyle } from '../../Themes'
import currencyLogo from '../../CurrencyLogo'

export interface Props {
  token: Token
  amount: Wei | undefined
  onAmountChange: (amount: Wei | undefined) => void
  onMax?: () => void
  balance: Wei | undefined
  showMax?: boolean
  leader: boolean
}

export const TokenInput: FC<Props> = (props: Props) => {
  const showMax = props.showMax || true

  const { token, onAmountChange, onMax, amount, leader, balance } = props
  /* Define if user inputs too much money*/
  const [exceed, setExceed] = useState(false)

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current && !leader) {
      if (amount === undefined || amount === '0') {
        inputRef.current.value = ''
      } else {
        try {
          inputRef.current.value = fromWei(amount, token.decimals).toString()
        } catch (e) {
          console.error({ amount })
        }
      }
    }
    if (amount && balance) {
      setExceed(Number(amount) > Number(balance))
    } else {
      setExceed(false)
    }
  }, [amount])

  return (
    <SwapInputPanel>
      <div className={'justify-between'}>
        <SwapInput
          small={true}
          exceed={exceed}
          ref={inputRef}
          onFocus={e => e.target.select()}
          onChange={e => {
            if (isNaN(Number(e.target.value))) {
              if (inputRef.current) {
                inputRef.current.value =
                  props.amount && props.token
                    ? fromWei(props.amount, props.token.decimals).toString()
                    : ''
              }
              return
            }
            const textValue = e.target.value
            try {
              let n: number | undefined = Number(textValue)
              if (isNaN(n)) {
                onAmountChange(undefined)
              } else {
                onAmountChange(toWei(n, token.decimals))
              }
            } catch (e) {
              onAmountChange(undefined)
            }
          }}
          placeholder={numericalPlaceholder}
        />
        <SwapInputCurrencyWrapper>
          <SwapInputCurrency isValidCurrency={token != undefined}>
            <CurrencyLogo src={coinImage(token.symbol)!} />
            <SwapInputSymbol>{token['symbol']}</SwapInputSymbol>
          </SwapInputCurrency>
        </SwapInputCurrencyWrapper>
      </div>
      <BalanceContainer visible={true}>
        <div className={'flex-row'}>
          <SimpleBalance
            exceed={exceed}
            balance={balance}
            decimals={token.decimals}
            loading={balance === undefined}
          />
          {showMax && (
            <MaxButton
              onMaxClick={() => {
                if (inputRef.current && balance && props.token) {
                  inputRef.current.value = fromWei(
                    balance,
                    props.token.decimals
                  ).toString()
                }
                setTimeout(() => {
                  // Execute after all effects on tokenInAmount
                  if (balance && onMax) {
                    //onAmountChange(balance)

                    onMax()
                  }
                }, 1)
              }}
            />
          )}
        </div>
      </BalanceContainer>
    </SwapInputPanel>
  )
}

const TokenSymbol = styled.span`
  display: flex;
  align-items: center;
  font-size: ${SwapStyle.normalText};
`

const BalanceContainer = styled.div<{ visible: boolean }>`
  justify-content: flex-end;
  display: flex;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`

const SwapInputCurrency = styled.div<{ isValidCurrency: boolean }>`
  display: flex;
  justify-content: start;
  align-self: center;
  font-size: 1.5em;
`
const SwapInputCurrencyWrapper = styled.div`
  display: inline-block;
  box-shadow: ${({ theme }) => theme.tradeCurrencyShadow};
  pointer-events: auto;

  background-color: ${({ theme }) => theme.tradeCurrencyBackgroundColor};
  border-radius: 1.8rem;
  padding: 0.7rem 1.4rem;
  font-size: 2.25rem;
  margin: 10px;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 2rem;
    margin: 5px;
    border-radius: 15px;
  }
`
